import moment from 'moment-timezone';

function companyClosingTime(date, timezone, closingTime) {
    let now = moment.tz(timezone);
    let parsed = moment(closingTime, "hh:mmA");
    let cutOffTime =  now.set({
      hour: parsed.hour(),
      minute: parsed.minute(),
      second: 0,
      millisecond: 0
    });
    return date > cutOffTime;
}

export default companyClosingTime;
